import axios, { AxiosRequestConfig } from "axios";
import { Tokens } from "../../types/webchatConversation";
import getAxiosConfig from "../other/axiosConfig";

const signInGuestHelper = async (nickname: string): Promise<string> => {
  const configData = { nickname };

  const config: AxiosRequestConfig = getAxiosConfig(
    "POST",
    "/users-auth/sign-in-guest",
    "Content-Type",
    configData,
  );

  const response = await axios(config);
  const { data } = response;
  const { code, data: jwtGuestToken } = data;

  if (code !== 201) {
    throw new Error("Sign in guest failed!");
  }

  // ✅ Sačuvaj token i u localStorage
  localStorage.setItem(Tokens.GUEST_TOKEN, jwtGuestToken);

  return jwtGuestToken;
};

export default signInGuestHelper;
